// ----------------------------------------------------------------------------
// Component: Hero Banner
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';
import Swiper, { Navigation, Pagination, EffectFade, Scrollbar, A11y, Keyboard, Autoplay, Thumbs } from 'swiper';
import 'snippets/background-media/background-media';

// Styles
import './_hero-banner.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
import 'swiper/css/thumbs';

// -------------------------------------
// Variables
// -------------------------------------

let heroBanner; // Declare in outer scope so event listeners can access it

// -------------------------------------
// Hooks
// -------------------------------------

function handleSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiperEl.slideTo(index);
        })
    });
}

$(function() {
    // Initialize feature collection slider based on the unique classes generated above.
    const sectionSlideCount = $('.carousel--hero-banner-tabs').data('slide-count');

    const heroBannerTabs = new Swiper(".carousel--hero-banner-tabs", {
        // Optional parameters
        modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
        slidesPerView: sectionSlideCount,
        spaceBetween: 0,
        threshold: 10,
        on: {
            tap: function() {
                heroBanner.autoplay.stop();
                $('.progress').hide();
            }
        }
    });

    heroBanner = new Swiper(".carousel--hero-banner", {
        // Optional parameters
        modules: [Navigation, Pagination, EffectFade, Scrollbar, A11y, Keyboard, Autoplay, Thumbs],
        slidesPerView: 1,
        spaceBetween: 0,
        a11y: false,
        watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
        autoplay:  {
            delay: 7000
        },
        thumbs: {
            swiper: heroBannerTabs,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        on: {
            autoplayStart: function () {
                const progress = document.querySelector('.progress');
                progress.classList.remove('progress--animate');
                // Force browser reflow to restart animation from beginning
                void progress.offsetWidth;
                progress.classList.add('progress--animate');
            },
            autoplayStop: function () {
                document.querySelector('.progress').classList.remove('progress--animate');
            },
            activeIndexChange: function () {
                const progress = document.querySelector('.progress');
                progress.classList.remove('progress--animate');
                // Force browser reflow to ensure animation restarts properly
                // Reading offsetWidth triggers layout recalculation before re-adding class
                void progress.offsetWidth;
                progress.classList.add('progress--animate');
            },
            touchMove: function () {
                heroBanner.autoplay.stop();
                document.querySelector('.progress').style.display = 'none';
            }
        }
    });

    const playButton = document.getElementById('play-button');
    const pauseButton = document.getElementById('pause-button');

    function updateButtonVisibility(isPlaying) {
        if (isPlaying) {
            playButton.style.display = 'none';
            pauseButton.style.display = 'block';
        } else {
            playButton.style.display = 'block';
            pauseButton.style.display = 'none';
        }
    }

    pauseButton.addEventListener('click', function () {
        heroBanner.autoplay.stop();
        updateButtonVisibility(false);
    });

    playButton.addEventListener('click', function () {
        heroBanner.autoplay.start();
        updateButtonVisibility(true);
        // Restart progress animation when manually resuming autoplay
        const progress = document.querySelector('.progress');
        progress.style.display = 'block';
        progress.classList.remove('progress--animate');
        void progress.offsetWidth; // Force reflow
        progress.classList.add('progress--animate');
    });

    // Initial button visibility setup
    updateButtonVisibility(true);

    // heroBanner.slides.forEach(function(slide, index) {
    //     let slideLink = slide.querySelector('a');
    //     slideLink.addEventListener('focus', function(e) {
    //         swiper.slideTo(index);
    //     })
    // });
});

document.addEventListener('DOMContentLoaded', function () {
    const pauseButtons = document.querySelectorAll('.pause-button');
    const playButtons = document.querySelectorAll('.play-button');

    pauseButtons.forEach((pauseButton) => {
        pauseButton.addEventListener('click', function () {
            if (heroBanner && heroBanner.autoplay) {
                heroBanner.autoplay.stop();
            } else {
                // Optional: Handle the error as needed
            }
        });
    });

    playButtons.forEach((playButton) => {
        playButton.addEventListener('click', function () {
            if (heroBanner && heroBanner.autoplay) {
                heroBanner.autoplay.start();
            } else {
                // Optional: Handle the error as needed
            }
        });
    });
});
